// Constants
import config from "./config"

// Images bucket url
export const CDN_URL =
  "https://s3.us-east-2.amazonaws.com/s3-stockperks-public.com"

export const Endpoints = {
  AUTH: {
    URL: `${config.apiHost}/oauth/token`,
  },
  LOGOUT: {
    URL: `${config.apiHost}/oauth/revoke`,
  },
  COMPANIES: {
    URL: `${config.apiHost}/api/companies`,
  },
  COMPANY_MESSAGES: {
    URL: `${config.apiHost}/api/v2/posts?companyId=:id&status=Active&sort=companyLevelPinned,desc&sort=weight,desc&sort=createdAt,desc`,
  },
  LOCATIONS: {
    URL: `${config.apiHost}/api/locations`,
  },
  MESSAGE: {
    URL: `${config.apiHost}/api/posts/:id`,
  },
  MESSAGES: {
    URL: `${config.apiHost}/api/posts`,
  },
  PERKS: {
    URL: `${config.apiHost}/api/perks`,
  },
  USERS: {
    URL: `${config.apiHost}/api/users`,
  },
  USER_COMPANY: {
    URL: `${config.apiGateway}/v1/users/:userId/company`,
  },
  USER_BROKERS: {
    URL: `${config.apiHost}/api/users/:userId/brokers`,
  },
  GATEWAY_USERS_V1: {
    URL: `${config.apiGateway}/v1/users`,
  },
  GATEWAY_USERS_V2: {
    URL: `${config.apiGateway}/v2/users`,
  },
  GATEWAY_EVENT_NOTIFICATIONS: {
    URL: `${config.apiGateway}/v1/event-notifications`,
  },
  UPLOADS: {
    URL: `${config.apiHost}/api/uploads`,
  },
  ROLES: {
    URL: `${config.apiHost}/api/roles`,
  },
  CONTACTS: {
    URL: `${config.apiHost}/api/contacts`,
  },
  CONTACT_US: {
    URL: `${config.apiHost}/internal/send/mail`,
  },
  RESET_PASSWORD: {
    URL: `${config.apiGateway}/v1/auth/password-reset?username=:username`,
  },
  RESET_AUTH_CODE: {
    URL: `${config.apiGateway}/public/v1/auth/authorize`,
  },
  REDEMPTION_TYPES: {
    URL: `${config.apiHost}/api/perk-redemption-types`,
  },
  COUPONS: {
    URL: `${config.apiHost}/api/coupons`,
  },
  PERK_REDEMPTIONS: {
    URL: `${config.apiHost}/api/v3/perk-redemptions`,
  },
  PERK_REDEMPTION: {
    URL: `${config.apiHost}/api/v2/perk-redemptions/:redemptionId`,
  },
  REDEEM: {
    URL: `${config.apiHost}/api/v2/perks/:perkId/redeem`,
  },
  SECURITIES: {
    URL: `${config.apiHost}/v1/securities`,
  },
  AGGREGATED_PORTFOLIOS: {
    URL: `${config.apiGateway}/v1/aggregated-portfolios/:userId`,
  },
  PORTFOLIOS: {
    URL: `${config.apiGateway}/v1/portfolios`,
  },
  PROOFS_OF_OWNERSHIP: {
    URL: `${config.apiGateway}/v2/proofs-of-ownership`,
  },
  PROOFS_OF_OWNERSHIP_V3: {
    URL: `${config.apiGateway}/v3/proofs-of-ownership`,
  },
  PROOFS_OF_OWNERSHIP_COUNTS: {
    URL: `${config.apiGateway}/v3/proofs-of-ownership/counts`,
  },
  PROOFS_OF_OWNERSHIP_ASSIGNED: {
    URL: `${config.apiGateway}/v3/proofs-of-ownership/assigned`,
  },
  PROOF_OF_OWNERSHIP_ASSIGNMENT: {
    URL: `${config.apiGateway}/v3/proofs-of-ownership/:id/assignment`,
  },
  PROOF_OF_OWNERSHIP: {
    URL: `${config.apiGateway}/v1/proofs-of-ownership/:id`,
  },
  PROOF_OF_OWNERSHIP_FILE: {
    URL: `${config.apiGateway}/v3/proofs-of-ownership-file/:fileId/url`,
  },
  PERK_REDEMPTION_FLOW: {
    URL: `${config.apiHost}/v1/perk-redemption-flows?perkCode=:perkCode`,
  },
  FORM: {
    URL: `${config.apiHost}/v1/dynamic-forms/:formId`,
  },
  PROOFS_OF_OWNERSHIP_INVALIDATION_REASONS: {
    URL: `${config.apiGateway}/v2/proofs-of-ownership-invalidation-reasons`,
  },
  POST_PROOF_OF_OWNERSHIP: {
    URL: `${config.apiGateway}/v2/proofs-of-ownership`,
  },
  PROOF_OF_OWNERSHIP_DATA: {
    URL: `${config.apiGateway}/v1/proof-of-ownership-data/:fileId`,
  },
  PROOF_OF_OWNERSHIP_DATA_CORRECTIONS: {
    URL: `${config.apiGateway}/v1/proof-of-ownership-data/:id/corrections`,
  },
  BROKER_CONNECTIONS_V2: {
    URL: `${config.apiGateway}/v2/broker-connections`,
  },
  BROKER_CONNECTIONS_V3: {
    URL: `${config.apiGateway}/v3/broker-connections`,
  },
  SPA_LOGIN: {
    URL: `${config.apiGateway}/public/v1/auth/spa/login`,
  },
  SPA_REFRESH: {
    URL: `${config.apiGateway}/public/v1/auth/spa/refresh`,
  },
  SPA_SESSION: {
    URL: `${config.apiGateway}/public/v1/auth/spa/session`,
  },
  SPA_LOGOUT: {
    URL: `${config.apiGateway}/public/v1/auth/spa/logout`,
  },
  SUPPORT_TICKETS: {
    URL: `${config.apiGateway}/v1/tickets`,
  },
  PERKS_ELIGIBILITY: {
    URL: `${config.apiGateway}/v2/perks-eligibility`,
  },
}
